import baseEmailSpellChecker from '@zootools/email-spell-checker';

export function checkIsEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function emailSpellChecker(email) {
  const suggestions = baseEmailSpellChecker.run({
    email,
    topLevelDomains: [...baseEmailSpellChecker.POPULAR_TLDS, 'lt'], // add lt to the list of top level domains
  });

  if (suggestions) {
    return suggestions.full;
  }

  return null;
}

export default emailSpellChecker;
